import axios from 'axios'
import { kyc_docs } from './KYCDetailsDataType'

const LOCAL_URL = process.env.REACT_APP_LOCALHOST
const API_TOKEN = localStorage.getItem('api_token') || ''

export const BUSINESS_TYPE_LIST = `${LOCAL_URL}/kyc/businessTypeList`
export const KYC_ACCOUNT_DOC_TYPES = `${LOCAL_URL}/kyc/kycAccountDocTypes`
export const CREATE_KYC = `${LOCAL_URL}/kyc/createKYC`

const headers = {
  Authorization: API_TOKEN,
}

// function to get business type list
export async function getBusinessTypeList() {
  return await axios.get(BUSINESS_TYPE_LIST, {headers})
}

// function to get KYC account document type
export async function getKYCAccountDocType() {
  return await axios.get(KYC_ACCOUNT_DOC_TYPES)
}

// function to create KYC for the user
export async function createKYC(
  account_kyc_name: string,
  business_registartion_type_uuid: string,
  business_name: string = '',
  address_1: string = '',
  address_2: string = '',
  country_id: number | string = '',
  province_id: number | string = '',
  city: string = '',
  pin_zip: string = '',
  account_holder_name: string = '',
  account_no: string = '',
  ifsc_swift_code: string = '',
  account_email_id: string = '',
  account_phone_number: string = '',
  kyc_docs: kyc_docs[] = []
) {
  return await axios.post(CREATE_KYC, {
    account_kyc_name,
    business_registartion_type_uuid,
    business_name,
    address_1,
    address_2,
    country_id,
    province_id,
    city,
    pin_zip,
    account_holder_name,
    account_no,
    ifsc_swift_code,
    account_email_id,
    account_phone_number,
    kyc_docs,
  })
}
